import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@chakra-ui/react';

import { useCatalogPath } from '~/hooks/use-catalog-path';

import { getNavigationData } from '../data';

import { Legal } from './legal';
import { Navigation } from './navigation';
import { NewsletterSignUp } from './newsletter';

export function PageFooter() {
  const { t } = useTranslation();
  const catalogPath = useCatalogPath();
  const navigationData = useMemo(() => getNavigationData(t, catalogPath), [t, catalogPath]);

  return (
    <Box bgColor='black' color='white'>
      <Box
        margin='auto'
        maxW={{ base: '100%', xl: '1240px' }}
        paddingStart={{ base: '16px', md: '24px', lg: '48px', xl: '0' }}
        paddingEnd={{
          base: '16px',
          md: '24px',
          lg: 'var(--track-padding-end, 48px)',
          xl: 'var(--track-padding-end, 0px)',
        }}
      >
        {/*
          When the fixed "Enroll Now" bar is at the bottom of course/program pages, use its
          measured height as the footer's bottom padding so the links clear it, plus 16px of
          breathing room. The --mobile-sticky-banner-offset var is published by whichever banner is
          visible (price-card.tsx or ab_plp_redesign_2025/mobile-sticky-banner.tsx) and falls back
          to 48px on desktop or when no banner is rendered, so the +16px keeps the default at 64px
          (CONENG-2334).
        */}
        <Box as='footer' pb='calc(var(--mobile-sticky-banner-offset, 48px) + 16px)' pt={{ base: '24px', md: '56px' }}>
          <Navigation navigation={navigationData} newsletter={<NewsletterSignUp />} />
          <Legal />
        </Box>
      </Box>
    </Box>
  );
}
